export const stripe = {
  subTitle:
    "Reliez votre compte Stripe pour facturer rapidement et facilement les réservations à vos clients, en évitant les commissions des agences de voyage en ligne.",
};
